import axios from "axios/index";
import api from "../../config/_api";
import {USER_GROUPS_UPDATED} from "../actions/user_groups";

const state = {
    user_groups: []
};
const actions = {
    getGroups: ({commit, rootGetters}) => {
        axios({url: api.url + 'user_groups?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('USER_GROUPS_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
};
const mutations = {
    [USER_GROUPS_UPDATED]: (state, user_groups) => {
        state.user_groups = user_groups;
    },
};
const getters = {
    user_groups : state => state.user_groups,
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
//# sourceMappingURL=user_groups.js.map